export const UnidadMedida = Object.freeze({
  MILLAR: 9,
  MILIMETRO: 21,
  PULGADA: 16,
  CENTIMETRO: 18,
  // Sustrato plano como llega del proveedor. En BD: 'hoja'. Espeja `UnidadMedida.HOJA` del
  // motor (`libs/cotizador/src/types.ts` en sispro-erp-server). Desde COTI-502, PLIEGO (23)
  // dejó de ser un alias suyo: son dos conceptos distintos y no se pueden intercambiar.
  HOJA: 20,
  // Lo que entra en máquina, no el ciclo de impresión. En BD: 'Pliego'. Hasta COTI-502 valía
  // 20 igual que HOJA, lo que hacía imposible distinguir los dos conceptos; el código 23 lo
  // asigna explícitamente la migración `20260806120000_add_unidad_medida_pliego` del backend.
  PLIEGO: 23,
});
